export default {
  title: 'Components/Text Field/Text Field',
  tags: ['autodocs'],
  argTypes: {
    size: {
      control: { type: 'select' },
      options: ['default','small'],
      description: 'Size of the input field',
    },
    placeholder: {
      control: 'text',
      description: 'Placeholder text for the input field',
    },
    label: {
      control: 'text',
      description: 'Label for the input field',
    },
    value: {
      control: 'text',
      description: 'Value of the input field',
    },
    type: {
      control: { type: 'select' },
      options: ['text', 'password', 'email', 'number', 'time', 'date', 'Witherror', 'disabled'   ],
      description: 'Type of the input field',
    },
    helper_text: {
      control: 'text',
      description: 'Helper or footer text',
    },
    error_message: {
      control: 'text',
      description: 'Error message displayed below the input field',
    },
    validation_type: {
      control: { type: 'select' },
      options: ['normal','error'],
      description: 'Validation type of the input field',
    },
    input_role:{
      control: 'text',
      description: 'Describe the role',
    },
    validation_id:{
      control: 'text',
      description: 'Validation ID of helper text and error text',
    },
    input_status: {
      control: { type: 'select' },
      options: ['normal','disabled'],
      description: 'Input status of the input field',
    },
    custom_class: {
      control: { type: 'text' }, // Add control for custom class
      description: 'Custom class for the input field',
    },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the input component',
    },
    input_id: {
      control: {type: 'text'},
      description: 'default',
    },
    aria_label: {
      control: {type: 'text'},
      description: 'Aria label for the input field',
    },
    onchange: {
      control: {type: 'text'},
      description: 'onchange event for the input field',
    },
    input_name: {
      control: {type: 'text'},
      description: 'Name of the input field',
    },
    required: {
      control: 'boolean',
      description: 'Marks the input as required',
    },
  },
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-input\` component, pass the following props:

\`\`\`html
<dda-input
  label="Email"
  placeholder="Enter email"
  input_role=""
  type="email"
  required="true"
  validation_type="error"
  error_message="Invalid email"
  input_id="email-id"
  aria_label="email"
></dda-input>
  \`\`\`
`,
      },
    },
  },
};

const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([key, value]) => value !== undefined && key !== 'text')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  return `<dda-input ${attributes}></dda-input>`;
};

export const Text = Template.bind({});
Text.args = {
  label: 'Text Input',
  placeholder: 'Enter text',
  type: 'text',
  input_id: 'input',
  value: '',
  input_role: '',
  input_name: 'input',
  aria_label: 'input',
  helper_text: 'Helper or footer text',
  error_message: 'Error text',
  validation_type: 'normal',
  validation_id: 'validationId',
  input_status: 'normal',
  size: 'default',
  custom_class: '',
  component_mode: '',
  inputChanged: '',
  required: false,
};

export const Password = Template.bind({});
Password.args = {
  label: 'Password Input',
  placeholder: 'Enter password',
  type: 'password',
  input_id: 'input',
  value: '',
  input_role: '',
  input_name: 'input',
  aria_label: 'input',
  helper_text: 'Helper or footer text',
  error_message: 'Error text',
  validation_type: '',
  validation_id: 'validationId',
  input_status: 'normal',
  size: 'default',
  custom_class: '',
  component_mode: '',
  inputChanged: '',
  
};

export const Email = Template.bind({});
Email.args = {
  label: 'Email Input',
  placeholder: 'Enter email',
  type: 'email',
  input_id: 'input',
  value: '',
  input_role: '',
  input_name: 'input',
  aria_label: 'input',
  helper_text: 'Helper or footer text',
  error_message: 'Error text',
  validation_type: '',
  validation_id: 'validationId',
  input_status: 'normal',
  size: 'default',
  custom_class: '',
  component_mode: '',
  inputChanged: '',
  
};

export const Number = Template.bind({});
Number.args = {
  label: 'Number Input',
  placeholder: 'Enter number',
  type: 'number',
  input_id: 'input',
  value: '',
  input_role: '',
  input_name: 'input',
  aria_label: 'input',
  helper_text: 'Helper or footer text',
  error_message: 'Error text',
  validation_type: '',
  validation_id: 'validationId',
  input_status: 'normal',
  size: 'default',
  custom_class: '',
  component_mode: '',
  inputChanged: '',
   
};
export const Date = Template.bind({});
Date.args = {
  label: 'Date Input',
  placeholder: '',
  type: 'date',
  input_id: 'input',
  value: '',
  input_role: '',
  input_name: 'input',
  aria_label: 'input',
  helper_text: 'Helper or footer text',
  error_message: 'Error text',
  validation_type: '',
  validation_id: 'validationId',
  input_status: 'normal',
  size: 'default',
  custom_class: 'dda-date-picker',
  component_mode: '',
  inputChanged: '',
  
};

export const Time = Template.bind({});
Time.args = {
  label: 'Time Input',
  placeholder: 'Enter Time',
  type: 'time',
  input_id: 'input',
  value: '',
  input_role: '',
  input_name: 'input',
  aria_label: 'input',
  helper_text: 'Helper or footer text',
  error_message: 'Error text',
  validation_type: '',
  validation_id: 'validationId',
  input_status: 'normal',
  size: 'default',
  custom_class: '',
  component_mode: '',
  inputChanged: '',
  
};

export const Witherror = Template.bind({});
Witherror.args = {
  label: 'Input with Error',
  placeholder: 'Enter value',
  type: 'text',
  input_id: 'input',
  value: '',
  input_role: '',
  input_name: 'input',
  aria_label: 'input',
  helper_text: 'Helper or footer text',
  error_message: 'Error text',
  validation_type: 'error',
  validation_id: 'validationId',
  input_status: 'normal',
  size: 'default',
  custom_class: '',
  component_mode: '',
  inputChanged: '',
  
};

export const disabled = Template.bind({});
disabled.args = {
  label: 'Number Input',
  placeholder: 'Enter number',
  type: 'number',
  input_id: 'input',
  value: '',
  input_role: '',
  input_name: 'input',
  aria_label: 'input',
  helper_text: 'Helper or footer text',
  error_message: 'Error text',
  validation_type: '',
  validation_id: 'validationId',
  input_status: 'disabled',
  size: 'default',
  custom_class: '',
  component_mode: '',
  inputChanged: '',
  
};